// extracted by mini-css-extract-plugin
export default {"input":"input-RJw7"};